import { render, staticRenderFns } from "./OpenEntityInCurrentWindowLink.vue?vue&type=template&id=418aa08c&"
import script from "./OpenEntityInCurrentWindowLink.vue?vue&type=script&lang=ts&"
export * from "./OpenEntityInCurrentWindowLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports